"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeSelect = TreeSelect;
var _react = _interopRequireDefault(require("react"));
var _reactCheckboxTree = _interopRequireDefault(require("react-checkbox-tree"));
var _colors = require("../../common/colors");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _InternalIcon = require("../icon/InternalIcon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function TreeSelect(_ref) {
  var checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    defaultExpanded = _ref.defaultExpanded,
    expanded = _ref.expanded,
    onCheck = _ref.onCheck,
    onExpand = _ref.onExpand,
    nodes = _ref.nodes;
  var _React$useState = _react.default.useState(defaultChecked || []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    internalChecked = _React$useState2[0],
    setInternalChecked = _React$useState2[1];
  var _React$useState3 = _react.default.useState(defaultExpanded || []),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    internalExpanded = _React$useState4[0],
    setInternalExpanded = _React$useState4[1];
  var isCheckedControlled = checked !== undefined;
  var isExpandedControlled = expanded !== undefined;
  _react.default.useEffect(function () {
    if (isCheckedControlled) setInternalChecked(checked);
  }, [checked, isCheckedControlled]);
  function handleCheck(newChecked, node) {
    if (onCheck) onCheck(newChecked, node);
    setInternalChecked(newChecked);
  }
  _react.default.useEffect(function () {
    if (isExpandedControlled) setInternalExpanded(expanded);
  }, [expanded, isExpandedControlled]);
  function handleExpanded(newExpanded, node) {
    if (onExpand) {
      onExpand(newExpanded, node);
    } else {
      setInternalExpanded(newExpanded);
    }
  }

  /**
   * We're just ignoring those icons that we never expect to have to use
   */
  var icons = {
    check: /*#__PURE__*/_react.default.createElement(_InternalIcon.CheckboxIcon, {
      icon: _InternalIcon.CheckboxIconNames.CHECKED,
      fill: _colors.Colors.SAGE_50
    }),
    uncheck: /*#__PURE__*/_react.default.createElement(_InternalIcon.CheckboxIcon, {
      icon: _InternalIcon.CheckboxIconNames.UNCHECKED,
      fill: _colors.Colors.SAGE_50
    }),
    halfCheck: /*#__PURE__*/_react.default.createElement(_InternalIcon.CheckboxIcon, {
      icon: _InternalIcon.CheckboxIconNames.INDETERMINATE,
      fill: _colors.Colors.SAGE_50
    }),
    expandClose: /*#__PURE__*/_react.default.createElement(_Icon.Icon16, {
      icon: _iconNames.IconNames16.CHEVRON_DOWN,
      fill: _colors.Colors.GREY_50
    }),
    expandOpen: /*#__PURE__*/_react.default.createElement(_Icon.Icon16, {
      icon: _iconNames.IconNames16.CHEVRON_RIGHT,
      fill: _colors.Colors.GREY_50
    }),
    expandAll: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    collapseAll: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    parentClose: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    parentOpen: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    leaf: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  };
  var defaultProps = {
    showExpandAll: false,
    showNodeIcon: false
  };
  return /*#__PURE__*/_react.default.createElement(_reactCheckboxTree.default, _extends({}, defaultProps, {
    icons: icons,
    nodes: nodes,
    checked: internalChecked,
    expanded: internalExpanded,
    onCheck: handleCheck,
    onExpand: handleExpanded
  }));
}